document.addEventListener("DOMContentLoaded", function() {

    const menu_btn = document.getElementById("js-header-menu__button");

    if (menu_btn) {
        menu_btn.onclick = function (event) {
            event.preventDefault();
            event.stopPropagation();
            const menu = document.getElementById("js-mobile-menu__wrapper");
            menu && menu.classList.toggle("active");
        };
    }

    const close_btn = document.getElementById("js-mobile-menu__close");

    if(close_btn){
        close_btn.onclick = function (event) {
            event.preventDefault();
            event.stopPropagation();
            const menu = document.getElementById("js-mobile-menu__wrapper");
            menu && menu.classList.toggle("active");
        };
    }

});